import {Component, OnInit}	from '@angular/core';
import {ContentNode}		from './content-node';
import {ContentService}		from './content.service';
import {Input} from "@angular/core";

import {TreeViewComponent} from './treeView.component';

@Component({
	selector: 'content-list',
	//directives: [ContentListComponent],
    //<div class="error" *ngIf="errorMessage">{{errorMessage}}</div>
	//			<a * ngIf="!contentNode.HasChildren" href= "{{_contentService._contentNodesUrl}}/getRequirmentsByCategoryId/{{contentNode.CATEGORY_ID}}" target= "_blank" class="leaf" > {{ contentNode.CATEGORY_DESC }}</a> 

    //template: `
	//	
	//`

    templateUrl: './content-list.component.template.html',
	styleUrls: ['../assets/css/treeView.css']
})
export class ContentListComponent implements OnInit {
	
	constructor(private _contentService: ContentService, private _treeViewComponent: TreeViewComponent) {}
	
	errorMessage: string;
	
	@Input('startingNode')
	private _startNodeId: string;

	@Input('isRoot')
    private _isRoot: boolean = false;

    @Input('isChild')
    private _isChild: boolean = false;

    @Input('level')
    private _level: number = 0;

    @Input('catId')
    private _catId: string = "1";

	@Input('isHidden')
    private _isHidden: boolean;
	
	contentNodes: ContentNode[];
	
	ngOnInit() { 
		//debugger;
		this.getContentNodes();
	}
	
	getContentNodes() {
		if (this._isRoot)
		this._contentService.getContentNodes(this._startNodeId, this._isRoot, this._catId)
			.subscribe(
				contentNodes => {
					this.contentNodes = [];
					contentNodes.forEach((node , ix, nodes)=>{
						this.contentNodes.push(new ContentNode(
							node.CATEGORY_ID,
							node.PARENT_CATEGORY_ID,
							node.CATEGORY_CODE,
							node.CATEGORY_DESC,
							node.CATEGORY_TYPE_ID,
							node.PARENT_CATEGORY_CODE,
							this._contentService.
								getChildNodes(node.CATEGORY_CODE).length>0
						));
					});

					this._treeViewComponent.ready()
				},
				error =>  this.errorMessage = <any>error
			);
		else{
			var nodes = this._contentService.getChildNodes(this._startNodeId);
					this.contentNodes = [];
					nodes.forEach((node , ix, nodes)=>{
						this.contentNodes.push(new ContentNode(
							node.CATEGORY_ID,
							node.PARENT_CATEGORY_ID,
							node.CATEGORY_CODE,
							node.CATEGORY_DESC,
							node.CATEGORY_TYPE_ID,
							node.PARENT_CATEGORY_CODE,
							this._contentService.
								getChildNodes(node.CATEGORY_CODE).length>0
						));
					});
			
		}
	}

	encodeURI(str) {
		return encodeURIComponent(str);
	}

	isInlineCss(desc: string) {
		//debugger;
		return this._level < 2 || desc.search(/[0-9,a-z,A-Z]/) != 0; // See items in Group 18 in Building-Permits 
			// and items in Group 1 in Business Licensing
	}
	
	toggleBranch(branchId:number){
		debugger;
		console.log('branchId: ' + branchId);
	}
}



// WEBPACK FOOTER //
// ./src/app/content-list.component.ts